import { IPayment, IReservationData, PaymentConditionItem } from "../services/model/get-trip-data.model";
import { IFlyTicketFormModel } from "./fly-ticket-form.model";
import { PaymentStatusEnum } from "src/app/enums/payment-status.enum";
import { IPaymentAttribute } from "src/app/services/model/pos.api.model";
import { TenderType } from "src/app/services/model/tender-type.enum";

export interface OfflinePaymentDialogContext {
    paymentType: TenderType;
    paymentName: string;
    paymentDisplayName?: string | null;
    currency?: string | null;
    paymentAttributes?: Array<IPaymentAttribute> | null;
}

export interface PaymentDialogResult extends IPayment {
    /** Requests that the parent replaces the current payment dialog with the offline card form. */
    openOfflineCardPaymentDialog?: boolean;
    /** Preserves the selected payment identity and attributes across the dialog transition. */
    offlinePaymentDialogContext?: OfflinePaymentDialogContext | null;
}

export interface PaymentDialogModel {
    paymentContext?: import("./payment-availability.model").PaymentContext;
    allowedPaymentNames?: readonly string[];
    remainingToPay: number;
    maxPaymentValue?: number;
    /** Return dialogs for flight/eTravel must use the completed payments as their cap. */
    returnAmountFromPayments?: boolean;
    skipBenefitPriceLimits?: boolean;
    totalPaid: number;
    totalPrice: number | null; // NULL means NO LIMIT
    paymentConditionItems: Array<PaymentConditionItem>;
    isReturn: boolean;
    payments: Array<IPayment>;
    offlineMode?: boolean;
    initialAmountToPay?: number | null;
    offlinePaymentContext?: OfflinePaymentDialogContext | null;
}



export function ToPaymentDialogModel(reservationData: IReservationData, isReturn?: boolean): PaymentDialogModel {

    let _isReturn = !!isReturn;

    return {
        remainingToPay: reservationData.remainingToPay,
        totalPaid: reservationData.totalPaid ?? 0,
        totalPrice: reservationData.totalPrice,
        paymentConditionItems: reservationData.reservation?.paymentSummary?.paymentConditionItems || [],
        isReturn: _isReturn,
        payments: reservationData.payments || []
    } as PaymentDialogModel;
}

export function FlightToPaymentDialogModel(
    flyTicketModel: IFlyTicketFormModel,
    payments: IPayment[],
    paymentConditionItemsOrIsReturn?: Array<PaymentConditionItem> | boolean,
    isReturn?: boolean,
): PaymentDialogModel {

    const paymentConditionItems = Array.isArray(paymentConditionItemsOrIsReturn)
        ? paymentConditionItemsOrIsReturn
        : [];
    const _isReturn = typeof paymentConditionItemsOrIsReturn === "boolean"
        ? paymentConditionItemsOrIsReturn
        : !!isReturn;
    const currentPayments = payments || flyTicketModel.payments || [];
    const totalPaid = currentPayments
        .filter(payment => payment.Status === PaymentStatusEnum.Done)
        .reduce((sum, payment) => sum + (Number(payment?.Amount) || 0), 0);

    return {
        // Flight/e-travel sales have no reservation amount and therefore stay unlimited.
        // Return dialogs opt into a payment-sum cap without changing remainingToPay,
        // which is also used by the benefit dialog's sale limits.
        remainingToPay: null,
        returnAmountFromPayments: _isReturn,
        skipBenefitPriceLimits: true,
        totalPaid,
        totalPrice: null,
        paymentConditionItems,
        isReturn: _isReturn,
        payments: currentPayments
    } as PaymentDialogModel;
}
